import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountCleanupWizardComponent } from '../account-cleanup-wizard/account-cleanup-wizard.component';
import { DowngradeStatusResponse } from '../../models/downgrade-response.model';

@Component({
    selector: 'app-downgrade-cleanup',
    templateUrl: './downgrade-cleanup.component.html',
    styleUrls: ['./downgrade-cleanup.component.scss'],
    standalone: false
})
export class DowngradeCleanupComponent implements OnInit {
    userId: any;
    upgradePlan: any;
    currentPlan: any;
    downgradeResponse!: DowngradeStatusResponse;

  constructor(public activeModal: NgbActiveModal, private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  close() {
    this.activeModal.dismiss();
  }

  next() {
    this.activeModal.close('next');
    const modalRef = this.modalService.open(AccountCleanupWizardComponent, {
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      centered: true
    });
    modalRef.componentInstance.userId = this.userId;
    modalRef.componentInstance.upgradePlan = this.upgradePlan;
    modalRef.componentInstance.currentPlan = this.currentPlan;
    modalRef.componentInstance.downgradeResponse = this.downgradeResponse;
    
    modalRef.result.then((result) => {
      // the chain continues in AccountCleanupWizardComponent
    });
  }
}
